import { restClient, restClientV2 } from '@/api/client'
import { endpoints } from '@/api/endpoints'

export type WithdrawalStatus = 'pending' | 'completed' | 'cancelled'

export interface WithdrawalRequest {
  id: number
  transfer_id: string
  user_id: number
  user_name: string
  user_email: string
  user_phone: string
  amount: number
  status: WithdrawalStatus
  bank_name: string
  account_number: string
  iban: string
  account_holder: string
  balance_before: number
  balance_after: number
  estimated_arrival: string | null
  admin_notes: string | null
  error_message: string | null
  completed_at: string | null
  created_at: string
  updated_at: string
}

export const withdrawalService = {
  // GET admin/withdrawals?status= — status omitted returns every request, newest-first.
  list: (status?: WithdrawalStatus): Promise<WithdrawalRequest[]> =>
    restClient.get(`${endpoints.withdrawals.list}${status ? `?status=${status}` : ''}`)
      .then(r => (r.data as any)?.data ?? []),

  // POST admin/withdrawals/:id/approve — marks transferred, no balance change (funds already held).
  approve: (id: number, admin_notes?: string) =>
    restClient.post(endpoints.withdrawals.approve(id), admin_notes ? { admin_notes } : {})
      .then(r => (r.data as any)?.data),

  // POST v2/admin/withdrawals/:id/reject — refunds the held amount back to the user.
  reject: (id: number, data: { reason: string; admin_notes?: string }) =>
    restClientV2.post(endpoints.withdrawals.reject(id), { reason: data.reason, admin_notes: data.admin_notes ?? '' })
      .then(r => (r.data as any)?.data),
}
